import {Routes, Route} from 'react-router-dom';
import HomePage from './pages/HomePage';
import About from './pages/About';
import Contact from './pages/Contact';
import Policy from './pages/Policy';
import Pagenotfound from './pages/Pagenotfound';
import Login from './pages/Auth/Login';
import AdminRoute from './components/Routes/AdminRoute';
import AdminDashboard from './pages/Admin/AdminDashboard';
import CreateCategory from './pages/Admin/CreateCategory';
import CreateProduct from './pages/Admin/CreateProduct';
import Users from './pages/Admin/Users';
import Products from './pages/Admin/Products';
import UpdateProduct from './pages/Admin/UpdateProduct';
import Search from './pages/Search';
import ProductDetails from './pages/ProductDetails';
import Categories from './pages/Categories';
import CategoryProduct from './pages/CategoryProduct';
import CartPage from './pages/CartPage';
import AdminOrders from './pages/Admin/AdminOrders';
import AdminPayments from './pages/Admin/AdminPayments';
import Settings from './pages/Admin/Settings';
import Invoice from './pages/Invoice';
import PaymentResult from './pages/PaymentResult';
import PayLink from './pages/PayLink';

function App() {
  return (
    <>
    <Routes>
      <Route path='/' element={<HomePage />} />
      <Route path='/products/:slug' element={<ProductDetails />} />
      <Route path='/categories' element={<Categories />} />
      <Route path='/cart' element={<CartPage />} />
      <Route path='/category/:slug' element={<CategoryProduct />} />
      <Route path='/search' element={<Search />} />
      <Route path='/invoice/:accessToken' element={<Invoice />} />
      <Route path='/payment/result' element={<PaymentResult />} />
      <Route path='/pay/:accessToken' element={<PayLink />} />

      {/* Admin routes - protected */}
      <Route path='/dashboard' element={<AdminRoute />}>
        <Route path='admin' element={<AdminDashboard />}/>
        <Route path='admin/create-category' element={<CreateCategory />}/>
        <Route path='admin/create-product' element={<CreateProduct />}/>
        <Route path='admin/products/:slug' element={<UpdateProduct />}/>
        <Route path='admin/products' element={<Products />}/>
        <Route path='admin/users' element={<Users />}/>
        <Route path='admin/orders' element={<AdminOrders />}/>
        <Route path='admin/payments' element={<AdminPayments />}/>
        <Route path='admin/settings' element={<Settings />}/>
      </Route>

      {/* Admin login - hidden from nav but accessible */}
      <Route path='/login' element={<Login />} />
      <Route path='/about' element={<About />} />
      <Route path='/contact' element={<Contact />} />
      <Route path='/policy' element={<Policy />} />
      <Route path='*' element={<Pagenotfound />} />
    </Routes>
    </>
  );
}

export default App;
